// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__YK0Mo","alertIcon":"ConfirmModal_alertIcon__3Y_4r"};